import { render, staticRenderFns } from "./RiderPerformanceChart.vue?vue&type=template&id=79c05a2a&scoped=true&"
import script from "./RiderPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./RiderPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./RiderPerformanceChart.vue?vue&type=style&index=0&id=79c05a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c05a2a",
  null
  
)

export default component.exports